<template>
    <el-dialog
        title="Créer facturation"
        :visible.sync="show"
        width="90%"
        :append-to-body="true"
        @close="reset"
    >
        <div class="billing-modal-container">
            <div class="preview-container">
                <billing-preview
                    :billData="organizedData"
                    :client="client"
                ></billing-preview>
            </div>
            <ns-loader
                ref="pricingListLoader"
                :toLoad="toLoad"
                class="form-container"
                @dataFetched="onDataFetched"
            >
                <el-form
                    slot="content"
                    ref="form"
                    :rules="rules"
                    :model="form"
                    label-width="200px"
                    label-position="left"
                >
                    <el-form-item label="Nom du client">
                        <el-select
                            v-model="form.client_uid"
                            placeholder="Sélectionner un client"
                            :disabled="clientSelectDisabled"
                            @change="setClient"
                        >
                            <el-option
                                v-for="item in clients"
                                :key="item.uid"
                                :label="item.name"
                                :value="item.uid">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Prestation : début" prop="start_date">
                        <el-date-picker
                            v-model="form.start_date"
                            type="date"
                            placeholder="Choisissez une date de début"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="Prestation : fin" prop="end_date">
                        <el-date-picker
                            v-model="form.end_date"
                            type="date"
                            placeholder="Choisissez une date de fin"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="Grille tarifaire" prop="selectedPriceGrid">
                        <el-select v-model="form.selectedPriceGrid" placeholder="Sélectionner une grille de tarif">
                            <el-option
                                v-for="item in priceLists"
                                :key="item.uid"
                                :label="item.name"
                                :value="item.uid"
                                :disabled="!item.in_use"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Offre">
                        <el-input type="number" v-model="form.free_simulation_number"></el-input>
                    </el-form-item>

                    <p>Ajouter des lignes</p>

                    <div class="extra-container">
                        <extra-billing-info
                            v-for="(extra, index) in form.extra_performance"
                            :key="index"
                            :index="index"
                            :extra="extra"
                            @saveInfo="saveInfo"
                            @removeExtra="removeExtra"
                        ></extra-billing-info>
                        <el-button type="text" class="new-line" @click="addExtra">+ Ajouter une prestation</el-button>
                    </div>

                    <p class="comment">Commentaire</p>

                    <el-input
                        class="comment-input"
                        v-model="form.comment"
                        placeholder="Insérer un commentaire"
                        type="textarea"
                        autosize
                    ></el-input>
                    <el-alert
                        v-if="!form.start_date || !form.end_date || !form.selectedPriceGrid"
                        title="Données insuffisantes pour calculer le montant"
                        type="warning"
                        style="margin-top: 15px;"
                        :closable="false"
                    >
                    </el-alert>
                    <el-alert
                        v-else-if="calculTotalAmountForSimulationInRange.totalSimulationInRange === 0"
                        ref="noDataInRangeAlert"
                        title="Aucune simulation trouvée dans cet intervalle de dates"
                        type="warning"
                        style="margin-top: 15px;"
                        :closable="false"
                    >
                    </el-alert>
                </el-form>
            </ns-loader>
        </div>

        <span slot="footer">
            <el-button type="default" @click="show = false">Annuler</el-button>
            <el-button type="primary" @click="create">Créer</el-button>
        </span>
    </el-dialog>
</template>

<script>
import BillingPreview from './preview.vue';
import ExtraBillingInfo from './extraBillingInfo.vue';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import moment from 'moment';
export default {
    components: {
        NsLoader,
        BillingPreview,
        ExtraBillingInfo,
    },
    data (){
        var checkDate = (rule, value, callback) => {
            if (rule.field === 'start_date' && !this.form.start_date) {
                return callback(new Error('Veuillez sélectionner une date'));
            } else if (rule.field === 'end_date' && !this.form.end_date) {
                return callback(new Error('Veuillez sélectionner une date'));
            } else if (moment(this.form.start_date).isAfter(moment(this.form.end_date))){
                return callback(new Error('La date de début ne peut pas être plus lointaine que la date de fin'));
            }
            callback();
        };
        return {
            show: false,
            clientSelectDisabled: false,
            client: {},
            form: {
                client_uid: '',
                start_date: '',
                end_date: '',
                selectedPriceGrid: '',
                free_simulation_number: 0,
                extra_performance: [],
                comment: '',
                total_amount: '',
            },
            rules: {
                start_date: [
                    {validator: checkDate, trigger: 'change'},
                    {required: true, message: 'Sélectionner une date de début', trigger: 'change'}
                ],
                end_date: [
                    {validator: checkDate, trigger: 'change'},
                    {required: true, message: 'Sélectionner une date de fin', trigger: 'change'}
                ],
                selectedPriceGrid: [
                    {
                        required: true,
                        message: 'Sélectionner une grille tarifaire afin de calculer le montant de la facture',
                        trigger: 'blur'
                    }
                ]
            },
            priceLists: [],
            clients: [],
        };
    },
    computed: {
        toLoad() {
            return [
                {
                    model: 'priceLists',
                    name: 'priceLists',
                },
                {
                    model: 'clients',
                    name: 'clients'
                }
            ];
        },
        summaryTTC() {
            let total = 0;
            total += this.calculTotalAmountForSimulationInRange.price * 1.20;
            this.form.extra_performance.forEach(extra => {
                total += (extra.unit_price_ht || 0) * (extra.quantity || 0) + Math.round(
                    (extra.unit_price_ht || 0) * (extra.quantity || 0) * (extra.vat / 100) * 100) / 100;
            });
            return total;            
        },
        organizedData() {
            let startDate = null;
            let endDate = null;
            if (this.form.start_date !== '') {
                startDate = moment(this.form.start_date).format('YYYY-MM-DD');
            }
            if (this.form.start_date !== '') {
                endDate = moment(this.form.end_date).format('YYYY-MM-DD');
            }
            return {
                'start_date': startDate,
                'end_date': endDate,
                'simulation_number': this.calculTotalAmountForSimulationInRange.totalSimulationInRange,
                'amount': this.calculTotalAmountForSimulationInRange.price,
                'free_simulation_number': this.form.free_simulation_number,
                'extra_performance': this.form.extra_performance,
                'comment': this.form.comment
            };
        },
        calculTotalAmountForSimulationInRange (){
            if(!this.form.start_date || !this.form.end_date || !this.form.selectedPriceGrid) return 0;
            let sDate = moment(this.form.start_date);
            let eDate = moment(this.form.end_date);
            let totalSimulationInRange = 0;
            let price = 0;
            for(let key in this.client.simulations_count_per_day){
                let date = moment(key);
                if(date.isBetween(sDate, eDate) || date.isSame(sDate)|| date.isSame(eDate)){
                    totalSimulationInRange += this.client.simulations_count_per_day[key];
                }
            }
            totalSimulationInRange = Math.max(totalSimulationInRange - this.form.free_simulation_number, 0);
            if(totalSimulationInRange === 0){
                return{
                    price,
                    totalSimulationInRange,
                };
            }
            let gridValues = this.priceLists.find((item) => item.uid === this.form.selectedPriceGrid).values;
            gridValues.sort((a, b) => {
                return a.min - b.min;
            });
            for(let val of gridValues){
                if(totalSimulationInRange >= val.min && totalSimulationInRange <= val.max){
                    price = val.price * totalSimulationInRange;
                    break;
                }
            }
            if(price === 0){
                price = gridValues.find((item) => item.max === null).price * totalSimulationInRange;
            }
            return {
                price,
                totalSimulationInRange,
            };
        },
    },
    methods: {
        setClient(value) {
            this.$set(this, 'client', this.clients.find(client => client.uid === value));
        },
        removeExtra(index) {
            this.form.extra_performance.splice(index, 1);
        }, 
        addExtra() {
            this.form.extra_performance.push({
                'label': '',
                'unit_price_ht': null,
                'quantity': 1,
                'vat': 20
            });
        },
        saveInfo(payload) {
            this.form.extra_performance[payload.index][payload.key] = payload.value;
        },
        open (client=null){
            this.$set(this, 'client', client ? client : {});
            this.show = true;
            this.form.client_uid = client ? client.uid : '';
            this.clientSelectDisabled = client ? true : false;
        },
        reset (){
            this.$set(this, 'form', {
                client_uid: '',
                start_date: '',
                end_date: '',
                selectedPriceGrid: '',
                free_simulation_number: 0,
                extra_performance: [],
                comment: '',
                total_amount: '',
            });
        },
        onDataFetched(resp) {
            this.$set(this, 'priceLists', resp.priceLists);
            this.$set(this, 'clients', resp.clients);
        },
        create (){
            if( this.calculTotalAmountForSimulationInRange.totalSimulationInRange === 0) {
                this.$refs.noDataInRangeAlert.$el.animate([
                    // keyframes
                    {
                        transform: 'translateX(0px)'
                    },
                    {
                        transform: 'translateX(5px)'
                    },
                    {
                        transform: 'translateX(0px)'
                    },
                    {
                        transform: 'translateX(-5px)'
                    },
                    {
                        transform: 'translateX(0px)'
                    },
                ], {
                    // timing options
                    duration: 150,
                    iterations: 3
                });
                return;
            }
            this.$refs.form.validate((valid) => {
                if(!valid) return;
                let item = {
                    'client_uid': this.form.client_uid,
                    'start_date': moment(this.form.start_date).format('YYYY-MM-DD'),
                    'end_date': moment(this.form.end_date).format('YYYY-MM-DD'),
                    'total_amount': this.summaryTTC,
                    'free_simulation_number': this.form.free_simulation_number,
                    'extra_performance': this.form.extra_performance,
                    'comment': this.form.comment,
                    'saved_data': {
                        'simulation_number': this.calculTotalAmountForSimulationInRange.totalSimulationInRange,
                        'unit_price': this.calculTotalAmountForSimulationInRange.price / this.calculTotalAmountForSimulationInRange.totalSimulationInRange,
                    }
                };
                this.$store.dispatch('createItem', {
                    item: item,
                    url: this.$store.state.api.meta.listModels.bills.url,
                    model: 'bills',
                }).then(() => {
                    this.$notify.success({title: 'Facturation créée'});
                    this.show = false;
                }).catch((e) => {
                    this.$notify.error({title: 'Erreur', message: 'Erreur lors de la création de la facture'});
                });
            });
        },
    },
};
</script>

<style lang="scss">
.billing-modal-container {
    display: flex;
    flex-direction: column;
    @media (min-width: 1152px) {
        flex-direction: row;
        justify-content: space-between;
        align-items: baseline;
    }
    .preview-container {
        order: 2;
        @media (min-width: 1152px) {
            order: 1;
            margin-right: 20px;
            width: 50%;
        }
    }
    .form-container {
        order: 1;
        @media (min-width: 1152px) {
            margin-top: 0;
            order: 2;
            margin-left: 20px;
            width: 50%;
        }
        .el-select, .el-input {
            width: 100%;
        }
        .total-amount {
            .el-form-item__content {
                margin-left: 0 !important;
            }
        }
    }
    .comment-input {
        textarea {
            resize: none;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Facturation/modal-create-facturation.vue